const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedCasino: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const casinolists = (state = initialState, action) => {
	switch (action.type) {
		case 'CASINOLIST_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'CASINOLIST_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'CASINOLIST_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'CASINOLIST_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'CASINOLIST_GET_CURRENT':
			return {
				...state,
				selectedCasino: action.selectedCasino,
			}
		case 'CASINOLIST_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default casinolists
